import { useHeroData } from "@/hooks/useHeroData";
import { resolveImagePath } from "@/utils/imageResolver";
import type { HeroData } from "@/data/types";

export function HeroSection() {
  const { heroData }: { heroData: HeroData } = useHeroData();

  return (
    <div className="bg-white">
      {/* Main Hero Content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        {/* Quicksilver Section */}
        <div className="bg-white p-6">
          <div className="mb-4">
            <a href={heroData.quicksilverSection.link.url}>
              <img
                src={resolveImagePath(heroData.quicksilverSection.image)}
                alt={heroData.quicksilverSection.imageAlt}
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </a>
          </div>
          
          <div className="space-y-4">
            <p className="text-sm text-gray-600 italic">
              {heroData.quicksilverSection.badge}
            </p>
            
            <div className="prose">
              <p className="text-gray-700 leading-relaxed">
                <em>
                  <strong>{heroData.quicksilverSection.highlights[0]}</strong> is proud to be the Full Service, <strong>
                    <a href={heroData.quicksilverSection.link.url} className="text-blue-600 hover:text-blue-800">
                      {heroData.quicksilverSection.highlights[1]}
                    </a>
                  </strong> / <strong>{heroData.quicksilverSection.highlights[2]}</strong> offering Sales, Service &amp; Support of Quicksilver Ultralight Aircraft since 1977. We are now able to ensure that the line of completed aircraft kits and replacement parts are available to the industry!
                </em>
              </p>
            </div>

            <h3 className="text-xl font-semibold text-blue-900">
              <a href={heroData.quicksilverSection.link.url} className="hover:text-blue-700">
                {heroData.quicksilverSection.link.text}
              </a>
            </h3>

            <div className="mt-4">
              <a
                href={heroData.quicksilverSection.socialLink.url}
                className="inline-block bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                {heroData.quicksilverSection.socialLink.text}
              </a>
            </div>
          </div>
        </div>

        {/* AERO1000 Engine Section */}
        <div className="bg-white p-6">
          <div className="mb-4">
            <a href={heroData.aeroSection.link.url}>
              <img
                src={resolveImagePath(heroData.aeroSection.image)}
                alt={heroData.aeroSection.imageAlt}
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </a>
          </div>

          <h3 className="text-xl font-semibold text-blue-900">
            <a href={heroData.aeroSection.link.url} className="hover:text-blue-700">
              {heroData.aeroSection.link.text}
            </a>
          </h3>
        </div>
      </div>

      {/* Sun-n-Fun Banner */}
      <div className="mb-8">
        <img
          src={resolveImagePath(heroData.banner.image)}
          alt={heroData.banner.imageAlt}
          className="w-full h-auto rounded-lg shadow-lg"
        />
      </div>
    </div>
  );
}